import { useScene } from '../../../../../context/sceneContext';
import { ComboInput } from '../../../baseInputs/ComboInput';
import { FilterComboInput } from './FilterComboInput';
import { OpacityInput } from './OpacityInput';
import { TransitionInput } from './TransitionInput';

export const EffectComboInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({
    opacity: undefined,
    filter: undefined,
    backdropFilter: undefined,
    animation: undefined,
    transition: undefined,
  });

  const updateData = (props: { [key: string]: any }) =>
    scene.updateSelectedElementsData(props, undefined, 'effectComboInput');

  return (
    <ComboInput
      label="Effect"
      inputs={[
        {
          name: 'Opacity',
          children: <OpacityInput value={data.opacity} onChange={(newValue) => updateData({ opacity: newValue })} />,
          isVisible: data.opacity !== undefined,
          onAdd: () => updateData({ opacity: 0.7 }),
          onRemove: () => updateData({ opacity: undefined }),
        },
        {
          name: 'Filter',
          children: (
            <FilterComboInput
              label="Filter"
              value={data.filter}
              onChange={(newValue) => updateData({ filter: newValue })}
            />
          ),
          isVisible: data.filter !== undefined,
          onAdd: () => updateData({ filter: '' }),
          onRemove: () => updateData({ filter: undefined }),
        },
        {
          name: 'Backdrop Filter',
          children: (
            <FilterComboInput
              label="Backdrop Filter"
              value={data.backdropFilter}
              onChange={(newValue) => updateData({ backdropFilter: newValue })}
            />
          ),
          isVisible: data.backdropFilter !== undefined,
          onAdd: () => updateData({ backdropFilter: '' }),
          onRemove: () => updateData({ backdropFilter: undefined }),
        },
        {
          name: 'Transition',
          children: (
            <TransitionInput 
              value={data.transition} 
              onChange={(newValue) => updateData({ transition: newValue })}
            />
          ),
          isVisible: data.transition !== undefined,
          onAdd: () => updateData({ transition: 'all 0.3s ease' }),
          onRemove: () => updateData({ transition: undefined }),
        },
      ]}
    />
  );
};
